'use strict';

/**
 * @function Initializes the page events depending on the checkout Redesign
 */

//Minicart mobile toggle redesign
function checkoutHeader() {

    // Store the window width
    var winWidth = $(window).width();
    $(window).on('resize orientationchange', function () {
        // to prevent calling of resize event while scrolling in IOS devices
        if ($(window).width() != winWidth && $('.product-item-container').hasClass('sb-container-noscroll') && $('.sticky-component .order-not-sticky').hasClass('active')) {
            // Update the window width for next time
            winWidth = $(window).width();
        }
    });


    $('.checkout-right-column').off().on('click', '.checkout-products.mobile-only', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var orderSticky = $('.checkout-right-column .order-not-sticky');
        if (!$(orderSticky).hasClass('active')) {
            $(orderSticky).addClass('active');
        } else {
            $(orderSticky).removeClass('active');
        }
        $(this).find('.icon-upCarrot').toggle();
        $(this).find('.icon-downCarrot').toggle();
    });

}


export default {
    init: function () {
        checkoutHeader();
    }
}
